var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgSurvey01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 240,
    viewBox: "0 0 80 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "right pattern"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1760_3826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 152,
    height: 424
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7823 4.63273L151.402 151.022V152.148L17.2222 5.14319C15.3772 3.12349 12.9218 2.05313 10.3596 2.05313C9.20784 2.05313 8.03391 2.26959 6.88472 2.71443C3.18105 4.14527 0.881836 7.4961 0.881836 11.4588V192.586C0.881836 234.814 16.5734 275.26 45.0655 306.475L151.402 422.975V424.1L44.5055 306.986C15.8844 275.631 0.122818 235.003 0.122818 192.586V11.4588C0.122818 7.17568 2.60901 3.5547 6.61066 2.00711C7.85205 1.52732 9.1199 1.29297 10.3664 1.29297C13.1344 1.29297 15.7905 2.4494 17.7823 4.63273Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1760_3826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7823 4.63273L151.402 151.022V152.148L17.2222 5.14319C15.3772 3.12349 12.9218 2.05313 10.3596 2.05313C9.20784 2.05313 8.03391 2.26959 6.88472 2.71443C3.18105 4.14527 0.881836 7.4961 0.881836 11.4588V192.586C0.881836 234.814 16.5734 275.26 45.0655 306.475L151.402 422.975V424.1L44.5055 306.986C15.8844 275.631 0.122818 235.003 0.122818 192.586V11.4588C0.122818 7.17568 2.60901 3.5547 6.61066 2.00711C7.85205 1.52732 9.1199 1.29297 10.3664 1.29297C13.1344 1.29297 15.7905 2.4494 17.7823 4.63273Z",
    fill: "url(#paint0_linear_1760_3826)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1760_3826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 242,
    width: 94,
    height: 240
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5038 243.719L151.402 335.079V481.203L82.2509 405.916C66.8427 389.139 58.3073 367.272 58.3073 344.588V247.256C58.3073 244.077 60.9269 242 63.6408 242C65.0128 242 66.4097 242.531 67.5038 243.719Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1760_3826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5038 243.719L151.402 335.079V481.203L82.2509 405.916C66.8427 389.139 58.3073 367.272 58.3073 344.588V247.256C58.3073 244.077 60.9269 242 63.6408 242C65.0128 242 66.4097 242.531 67.5038 243.719Z",
    fill: "url(#paint1_linear_1760_3826)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1760_3826",
    x1: 151.402,
    y1: 212.696,
    x2: 0.122818,
    y2: 212.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1760_3826",
    x1: 151.402,
    y1: 361.601,
    x2: 58.3073,
    y2: 361.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB764"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSurvey01);
export default __webpack_public_path__ + "static/media/bg_survey_01.e758f377d098ac4d52697a2adfdf04ad.svg";
export { ForwardRef as ReactComponent };